import React, {useState, useEffect} from 'react'
import Title from 'components/TitleWithIcon';
import { useStyles } from "./UserInformationStyle";
import {AccountCircle, Email, Filter1, TextFields, Home, PersonPinCircle } from '@material-ui/icons';
import {Container, Chip, Grid, List, ListItem, ListItemIcon, ListItemText, Divider} from '@material-ui/core';
// Api Services
import ApiServices from 'services/ApiServices';
//components
import LoadingSpinner from 'components/LoadingSpinner';

import {showMessagePersonalizedPosition} from 'services/SweetAlert'

export default function UserInformation (props) {
    const classes = useStyles(),
    [datosUsuario, setDatosUsuario] = useState({rolUsuario:'', puestoEmpadronamiento:'', departamentoMunicipio: ''}),
    [loading, setLoading] = useState(false)

    const ObtenerDatosUsuario = async () => {
        setLoading(true)
        try{
            let response = await ApiServices.solicitudesDeEmpadronamiento.usuariosGeo();
            if(response.error){
                showMessagePersonalizedPosition('warning','¡Advertencia!', response?.error?.message,'center')
            }else {
                setDatosUsuario({rolUsuario: response.data.descripcionUsuario, puestoEmpadronamiento: response.data.nombrePuestoEmpadronamiento, departamentoMunicipio: response.data.nombreDepartamentoEmpadronamiento+', '+response.data.nombreMunicipioEmpadronamiento})
            } 
        }catch(exception){
            if (exception.status===404) {
                showMessagePersonalizedPosition('error', '¡Advertencia!', "Intente de nuevo. Ponganse en contacto con el Administrador sí este mensaje persiste.", 'center')
            }
            else {
                showMessagePersonalizedPosition('error', '¡Advertencia!', "Intente de nuevo. Ponganse en contacto con el Administrador sí este mensaje persiste.", 'center')
            }
        }        
        setLoading(false)
    }

    useEffect(() => {
        // console.log('currentUser: state.security.currentUser, ', props.DatosUsuario);
        ObtenerDatosUsuario();
    },[])
    return (
        <Container>        
            <LoadingSpinner open={loading}/>        
            <Grid className={classes.colorComponente}>
                <Grid item xs={12}>                    
                        <Title title="Datos del Usuario" icon={"/assets/DatosUsuario.png"}/>    
                        <List className={classes.rootLista} dense>
                            <ListItem>
                                <ListItemIcon className={classes.colorIcon}><Filter1/></ListItemIcon>
                                <ListItemText className={classes.colorIcon} primary="No. de Empleado: " />
                                <Chip className={classes.colorChip} label={props.DatosUsuario.code} />                                
                            </ListItem>
                            <ListItem>
                                <ListItemIcon className={classes.colorIcon}><TextFields/></ListItemIcon>
                                <ListItemText className={classes.colorIcon} primary="Nombre completo: " />
                                <Chip className={classes.colorChip} label={props.DatosUsuario.name} />                                
                            </ListItem>
                            <ListItem>
                                <ListItemIcon className={classes.colorIcon}><AccountCircle/></ListItemIcon>
                                <ListItemText className={classes.colorIcon} primary="Rol en el sistema: " />
                                <Chip className={classes.colorChip} label={props.DatosUsuario?.rol?.name} />                                
                            </ListItem>
                            <ListItem>
                                <ListItemIcon className={classes.colorIcon}><AccountCircle/></ListItemIcon>
                                <ListItemText className={classes.colorIcon} primary="Descripción: " />
                                <Chip className={classes.colorChip} label={datosUsuario.rolUsuario} />                                
                            </ListItem>
                            <ListItem>
                                <ListItemIcon className={classes.colorIcon}><Home/></ListItemIcon>
                                <ListItemText className={classes.colorIcon} primary="Puesto Empadronamiento: " />
                                <Chip className={classes.colorChip} label={datosUsuario.puestoEmpadronamiento} />                                
                            </ListItem>
                            <ListItem>
                                <ListItemIcon className={classes.colorIcon}><PersonPinCircle/></ListItemIcon>
                                <ListItemText className={classes.colorIcon} primary="Departamento/Municipio: " />
                                <Chip className={classes.colorChip} label={datosUsuario.departamentoMunicipio} />                                
                            </ListItem>
                            <ListItem>
                                <ListItemIcon className={classes.colorIcon}><Email/></ListItemIcon>
                                <ListItemText className={classes.colorIcon} primary="Correo electrónico: " />
                                <Chip className={classes.colorChip} label={props.DatosUsuario.email} />                                
                            </ListItem>
                        </List>
                        <br/>
                </Grid>
            </Grid>               
        </Container>                
    )
}